const weeklyAptCalculator = (quarterTarget = 0, avgCaseSize = 0, closingRate = 0) => {
  let weeklyAppt = 0;
  if (quarterTarget > 0 && avgCaseSize > 0 && closingRate > 0) {
    weeklyAppt = (quarterTarget / 13 / avgCaseSize / closingRate).toFixed(1);
  }
  return weeklyAppt;
};

module.exports.weeklyAptCalculator = weeklyAptCalculator;
